import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const DepositCategoryList = () => {
  const location = useLocation();
  const [categoryData, setCategoryData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await Http.get(`/accounts/deposit-categories`);
      const resRole = await Http.get(`/staff-type-check`);
      
      // Transform the data to convert numeric status to string format expected by ReactDataTable
      const transformedData = res.data.map(item => ({
        ...item,
        status: item.status === 1 ? "active" : "inactive"
      }));
      
      setCategoryData(transformedData);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (location.state) {
      setAlert({
        message: location.state.message,
        type: location.state.type,
      });
    }
  }, [location]);

  const cols = [
    { field: "name", header: "Category Name" },
    { field: "status", header: "Status" },
  ];

  const actionTemplate = (row) => (
    <div className="d-flex">
      <Link
        to={`/view-deposit-category/${row.id}`}
        className="btn btn-sm btn-info me-1"
        title="View"
      >
        <i className="fa fa-eye"></i>
      </Link>
      {(role === "admin" || role === "accounts") && (
        <>
          {row.id > 7 ? (
            <Link
              to={`/edit-deposit-category/${row.id}`}
              className="btn btn-sm btn-warning me-1"
              title="Edit"
            >
              <i className="fa fa-edit"></i>
            </Link>
          ) : (
            <></>
          )}
          {/* <button
            className="btn btn-sm btn-danger"
            onClick={() => DatatableFunc.deleteData(row.id, "/accounts/deposit-categories", fetchData)}
            title="Delete"
          >
            <i className="fa fa-trash"></i>
          </button> */}
        </>
      )}
    </div>
  );

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Deposit Categories</h5>
            <div className="am-right">
              {(role === "admin" || role === "accounts") && (
                <Link
                  to="/create-deposit-category"
                  className="btn btn-primary"
                >
                  <i className="fa fa-plus"></i> Add New Deposit Category
                </Link>
              )}
            </div>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={categoryData}
                isLoading={loading}
                actionTemplate={actionTemplate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositCategoryList;